import IMAGES from 'assets/images';
import { IAdditionalDocument } from 'core/utilities';
import React from 'react';
import { AddIcon, ExpandButton, TrashIcon } from './DocActionButtons.styles';

interface IProps {
    document: IAdditionalDocument;
    isSelected: boolean;
    isUploadingOrDeleting: boolean;
    onDelete: () => void;
}

const DocActionButton: React.FC<IProps> = ({ document, isSelected, isUploadingOrDeleting, onDelete }) => {
    return (
        !document.uploaded ? (
            <ExpandButton>
                <AddIcon rotated={isSelected}>+</AddIcon>
            </ExpandButton>
        ): (
            <TrashIcon onClick={onDelete} src={IMAGES.icTrash} uploading={isUploadingOrDeleting} />
        )
    );
};

export default DocActionButton;
